
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/queue-for-you-near-me/[...slug]",
      function () {
        return require("private-next-pages/queue-for-you-near-me/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/queue-for-you-near-me/[...slug]"])
      });
    }
  